import wPill from './w-pill.vue';

import { installer } from '#util';

export const Pill = { install: installer([wPill]) };
export { wPill };
